import { useMemo } from "react";
import { useSelector } from "react-redux";
import {
  selectAuth,
  selectAuthPermissions,
  selectAuthRoles,
  selectAuthUserTypes,
} from "../../../features/auth/authSlice";
import {
  canViewSalesOverviewTab,
  hasDashboardPermission,
  isAdminUser,
  isClaimsUser,
  isIssuanceUser,
  isOperatorUser,
  isSalesUser,
} from "../../../utils/roleAccess";

export default function useAuthRoles() {
  const auth = useSelector(selectAuth);
  const roles = useSelector(selectAuthRoles);
  const userTypes = useSelector(selectAuthUserTypes);
  const permission = useSelector(selectAuthPermissions);

  return useMemo(
    () => ({
      auth,
      roles,
      userTypes,
      permission,
      canViewSalesOverview: canViewSalesOverviewTab(auth),
      canAccessDashboard: hasDashboardPermission(permission),
      isOperatorUser: isOperatorUser(userTypes, roles),
      isAdminUser: isAdminUser(userTypes, roles),
      isSalesUser: isSalesUser(roles, permission),
      isIssuanceUser: isIssuanceUser(roles, permission),
      isClaimsUser: isClaimsUser(roles, permission),
    }),
    [auth, permission, roles, userTypes]
  );
}
